import React from 'react'
import Home from '../../Component/Home/Home'


const HomePage = () => {
  return (
    <>
    <Home/>
    </>
  )
}

export default HomePage